module.exports = __webpack_public_path__ + "static/img/job2.beb9fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/job2.png
// module id = M5Fp
// module chunks = 0